import { useEffect, useState } from "react";

import { AmountSelectorWrapper } from "./style";
import { isEmpty } from "../../utils/common";



export default function AmountSelector({select,options,totalAmount=0}) {
  const [selected, setSelected] = useState("Total Amount Due");

 

  return (
    <AmountSelectorWrapper className="amount-wrapper">
      <p className="title">You can also select from below amount:</p>

   <label
         
          className={`amount-card ${
            selected === "Total Amount Due" ? "active" : ""
          }`}
        >
          <input
            type="radio"
            name="amount"
            checked={selected === "Total Amount Due"}
            onChange={() => {
              setSelected("Total Amount Due");
              select(totalAmount)
            }}
          />

          <div className="amount-text">
            <span className="label">{"Total Amount Due"} :</span>
            <span className="value">₹{totalAmount}</span>
          </div>
        </label>
      {options.map((option, index) => (
        <label
          key={index}
          className={`amount-card ${
            selected === option?.name ? "active" : ""
          }`}
        >
          <input
            type="radio"
            name="amount"
            checked={selected === option?.name}
            onChange={() => {
              setSelected(option?.name);
              select(option?.value)
            }}
          />

          <div className="amount-text">
            <span className="label">{option?.name} :</span>
            <span className="value">₹{option?.value}</span>
          </div>
        </label>
      ))}
    </AmountSelectorWrapper>
  );
}
